import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import DetailsKV from "@eres/ejari-web/component/DetailsKV";
import { CurrencyUtil, LocaleUtil } from "@eres/core";
import { SellRequestInfo } from "../../../../apis/privatesell/enitites";
import { FormContainer } from "../Base";

interface Props {
	sellRequest?: SellRequestInfo;
}

export default class ViewBookingDetails extends Component<Props> {
	render() {
		const sellRequest = this.props.sellRequest!;
		return <FormContainer title={ Strings.booking_details }>
			<div className="flex-grid">
				<DetailsKV
					label={ Strings.asking_price }
					value={ CurrencyUtil.toFormattedCurrency( Number( sellRequest.askingPrice ) ) + " " + Strings.aed }/>
				<DetailsKV label={ Strings.offer_period } value={ LocaleUtil.getLocalValue( sellRequest.transactionDuration ) }/>
			</div>
		</FormContainer>;
	}
}
